<template>
    <div>
        <div class="action-header">
            <el-button @click="showDialog" icon="el-icon-plus" type="primary">新建施工点</el-button>
            <el-input class="input" clearable placeholder="请输入施工点关键字" v-model="key">
                <i
                    @click="handleSearch"
                    class="el-input__icon el-icon-search btn-search"
                    slot="suffix"
                />
            </el-input>
        </div>

        <Table />

        <Pagination />

        <!-- 新建(编辑)施工点表单 dialog -->
        <DialogSite />
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { DIALOG_ADD } from '../../libs/enum.js';
import Table from './table';
import Pagination from './pagination';
import DialogSite from './dialog.site';

const { mapState, mapActions } = createNamespacedHelpers('site');

export default {
    components: { Table, Pagination, DialogSite },
    data() {
        return {
            key: '',
        };
    },
    methods: {
        ...mapActions([
            'changeDialog',
            'searchSites',
            'changeSearch',
            'clearState',
        ]),
        showDialog() {
            this.changeDialog({ visible: true, type: DIALOG_ADD });
        },
        handleSearch() {
            this.changeSearch({ key: this.key, page: 1 });
        },
    },
    mounted() {
        this.searchSites();
    },
    beforeDestroy() {
        this.clearState();
    },
};
</script>

<style lang="less" scoped>
.action-header {
    margin-bottom: 20px;
    .input {
        float: right;
        width: 250px;
    }
}
.btn-search {
    width: 30px;
    font-size: 18px;
    cursor: pointer;
    &:hover {
        color: #409eff;
    }
}
</style>
